import React from 'react'
import { NavLink } from 'react-router-dom'
import Header from '../Components/Header'
import Footer from '../Components/Footer'

function Overview() {
  return (
    <div>
      <Header />
      {/* Breadcrumbs */}
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>Company profile</h2>
                <ul className="bread-list">
                  <li><NavLink to='/'>Home</NavLink></li>
                  <li><i className="icofont-simple-right" /></li>
                  <li className="active">Company profile</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Breadcrumbs */}
      {/* Error Page */}
      <section className="overview-section section" style={{ backgroundColor: '#f9f9f9', padding: '60px 0' }}>
        <div className="container">
          <div className="row align-items-center shadow-sm bg-white p-4 rounded-3">
            {/* Text Content */}
            <div className="col-lg-6 mb-4 mb-lg-0" style={{ lineHeight: '1.8', fontSize: '1.1rem', color: '#333' }}>
              <h3 className="text-primary mb-4" style={{ fontSize: '2rem' }}>Our Company Profile</h3>

              <p style={{ textAlign: 'justify', fontSize: '14px', color: '#333' }}>
                <strong>WEBNET TECHNOLOGIES</strong> are a provider of Custom Software Solutions, Professional Website Design and Corporate Training Services, aimed at delivering services which open new possibilities for our customers and allow them to work effectively and creatively. We have expertise in development, customization and integration of complex enterprise-level solutions offering a well-balanced blend of technology skills, domain knowledge, hands-on experience, effective methodology, and passion for IT. We cover the full software development life cycle from business analysis to quality assurance and deployment and post-launch maintenance.
              </p>
              <p style={{ textAlign: 'justify', fontSize: '14px', color: '#333' }}>
                <strong>WEBNET TECHNOLOGIES </strong> provides a range of IT solutions for achieving superior business results in areas of Enterprise Application Solutions and Integrated IT Solutions.
              </p>
              <p style={{ textAlign: 'justify', fontSize: '14px', color: '#333' }}><strong>WEBNET TECHNOLOGIES </strong> has delivered successful Enterprises Application Solutions to many high profile organizations in Bihar. It even includes CRM solutions and e-Commerce portals. We have in-house organizational consultants who specialize in aligning organizational strategy, systems, and processes to deliver superior results.</p>

            </div>

            {/* Image */}
            <div className="col-lg-6">
              <img
                src="img/blog2.jpg" // <-- Replace this with your actual image path in the `public/images/` folder
                alt="CompanyOverview"

              />

            </div>

          </div>
        </div>
      </section>
      {/*/ End Error Page */}
      <Footer />
    </div>
  )
}

export default Overview